import { render, staticRenderFns } from "./CHeaderButton.vue?vue&type=template&id=18ff192b&scoped=true&"
import script from "./CHeaderButton.vue?vue&type=script&lang=js&"
export * from "./CHeaderButton.vue?vue&type=script&lang=js&"
import style0 from "./CHeaderButton.vue?vue&type=style&index=0&id=18ff192b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff192b",
  null
  
)

export default component.exports